export default function parseQuery(str) {
  if (typeof str != "string" || str.length == 0) return {};
  var s = str.split("&");
  var s_length = s.length;
  var bit,
    query = {},
    first,
    second;
  for (var i = 0; i < s_length; i++) {
    bit = s[i].split("=");
    first = decodeURIComponent(bit[0]).replace("?", "");
    if (first.length == 0) continue;
    second = decodeURIComponent(bit[1]);
    if (typeof query[first] == "undefined") query[first] = second;
    else if (query[first] instanceof Array) query[first].push(second);
    else query[first] = [query[first], second];
  }
  return query;
}
